export default {"src":"/_next/static/media/menu-close-colapse-mobile.54763b15.svg","height":32,"width":56,"blurWidth":0,"blurHeight":0};